import { ReactNode } from 'react'
import { ButtonSize, ButtonTheme } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import Icon24 from 'builder/components/Icon'
import { SectionNames } from 'builder/modules/resumeEditor'
import { NavigationDots } from '../NavigationDots/NavigationDots'
import { LOCALIZATION_PREFIX } from '../../constants'
import { StepByStepSectionData } from '../../constructSectionsData'
import { ResumeWritingActions, useResumeWriting } from '../ResumeWritingBanner'

import {
  NavigationSectionContainer,
  BackContainer,
  NextContainer,
  ActionContainer,
  NextButton,
  BackButton,
  NavigationBorder,
  BorderTop,
  BorderBottom,
} from './styles'

type Props = {
  handleBack?: () => void
  handleNext?: () => void
  nextButtonText?: string
  currentIndex: number
  sections?: StepByStepSectionData[]
  isBackButtonPassive?: boolean
  children?: ReactNode
  isNextActionInProgress?: boolean
}

export const NavigationSection = (props: Props) => {
  const {
    handleBack,
    handleNext,
    nextButtonText,
    currentIndex,
    sections = [],
    isBackButtonPassive,
    children,
    isNextActionInProgress,
  } = props
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const { isBannerVisible: isResumeWritingBannerVisible } = useResumeWriting()
  const dotsProps = { currentIndex, sections }
  const activeSection = sections[currentIndex]
  const shouldShowBannerActions =
    activeSection?.id === SectionNames.educations && isResumeWritingBannerVisible

  const BannerActions = ResumeWritingActions

  return (
    <NavigationSectionContainer>
      <NavigationBorder>
        <BorderTop />
        <BorderBottom />
      </NavigationBorder>
      {shouldShowBannerActions ? (
        <BannerActions />
      ) : (
        <>
          <ActionContainer>
            <BackContainer>
              {!isBackButtonPassive && (
                <BackButton
                  onClick={handleBack}
                  size={isPhone ? ButtonSize.small : ButtonSize.default}
                  theme={ButtonTheme.ghost}
                >
                  {isPhone ? (
                    <Icon24.ChevronLeft />
                  ) : (
                    i18n.t(`${LOCALIZATION_PREFIX}.navigation_container.back_button_text`)
                  )}
                </BackButton>
              )}

              {!isPhone && !!sections.length && <NavigationDots {...dotsProps} />}
            </BackContainer>
            {!isPhone && children}
            <NextContainer>
              <NextButton
                size={isPhone ? ButtonSize.small : ButtonSize.default}
                onClick={handleNext}
                isLoading={isNextActionInProgress}
                disabled={isNextActionInProgress}
              >
                {nextButtonText}
              </NextButton>
            </NextContainer>
            {isPhone && children}
          </ActionContainer>
          {isPhone && !!sections.length && <NavigationDots {...dotsProps} />}
        </>
      )}
    </NavigationSectionContainer>
  )
}
